export default __webpack_public_path__ + "images/b360f47814c517e3a4fec94253c8bf7c.svg";